// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AllRollbackEmployeePayModal__wrap--2vKUL","notes":"AllRollbackEmployeePayModal__notes--2Mc6y m-list-notes"};